/**
 * @file: MediaAlbum.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export interface MediaAlbum<T = any> {
  value: T;
  label: string | null | undefined;
  coverUrl: string;
  mediaCount: number;
  active?: boolean;
}

export type MediaAlbumYearMonthGroupKey = {
  year: number;
  month: number;
};

export type MediaAlbumByYearMonth = MediaAlbum<MediaAlbumYearMonthGroupKey>;

export function isAlbumByYearMonth(
  album: MediaAlbum,
  // @ts-ignore
): album is MediaAlbumByYearMonth {
  return (
    album.value &&
    typeof album.value === 'object' &&
    'year' in album.value &&
    'month' in album.value
  );
}
